import React, { useState } from 'react';
import Checked from "../../images/checked.svg";
import Unchecked from "../../images/unchecked.svg";
import ChevronDown from "../../images/chevron-down.svg";
import ChevronUp from "../../images/chevron-up.svg";
import { OnboardingTask } from "./types";
import { portalSecondaryPillButton } from "../../theme/portalLayout";

interface Props {
  task: OnboardingTask
}

function OnboardingTaskItem({ task }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
      <li className="list-none">
        <div
          className="flex flex-col gap-3 rounded-xl border border-portal-teal/10 bg-background-blu/40 px-4 py-4 sm:flex-row sm:items-start sm:justify-between sm:gap-4"
        >
          <div className="flex min-w-0 flex-1 gap-3">
            { task.isComplete
              ? <img className="mt-0.5 h-7 w-7 shrink-0" src={Checked} alt="" aria-hidden="true" />
              : <img className="mt-0.5 h-7 w-7 shrink-0" src={Unchecked} alt="" aria-hidden="true" />
            }
            <div className="min-w-0 flex-1">
              <h4 className="font-sans-co text-base font-bold text-portal-teal sm:text-lg">{task.title}</h4>
              { task.description && (
                <button
                  type="button"
                  className="mt-1 inline-flex items-center gap-1 text-p3 font-medium text-portal-teal/80 hover:text-portal-teal"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  <span>{isExpanded ? 'Hide details' : 'Show details'}</span>
                  <img src={isExpanded ? ChevronUp : ChevronDown} alt="" className="h-4 w-4 opacity-70" aria-hidden="true" />
                </button>
              )}
              { isExpanded && task.description && (
                <p className="mt-2 text-p2 leading-relaxed text-portal-teal/85">{task.description}</p>
              )}
            </div>
          </div>
          { task.url && !task.isComplete && (
            <a
              className={`${portalSecondaryPillButton} shrink-0 self-start !text-portal-teal visited:!text-portal-teal sm:self-center`}
              href={task.url}
            >
              Continue
            </a>
          )}
        </div>
      </li>
    );
}

export default OnboardingTaskItem;
